import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconRefresh = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7472 7.62277C13.797 6.54742 11.3706 6.89158 9.7963 8.46686C9.78915 8.47401 9.78189 8.48106 9.77453 8.48799L8.52289 9.66664H10.0023C10.5546 9.66664 11.0023 10.1144 11.0023 10.6666C11.0023 11.2189 10.5546 11.6666 10.0023 11.6666H6.0023C5.45002 11.6666 5.0023 11.2189 5.0023 10.6666V6.66664C5.0023 6.11436 5.45002 5.66664 6.0023 5.66664C6.55459 5.66664 7.0023 6.11436 7.0023 6.66664V8.35136L8.3928 7.04195C10.5971 4.84608 13.9872 4.36841 16.7129 5.87136C19.4433 7.37686 20.8488 10.5067 20.16 13.5476C19.4713 16.5885 16.8543 18.8072 13.7418 18.9893C10.6292 19.1714 7.77138 17.2729 6.73275 14.3331C6.54878 13.8123 6.82178 13.2411 7.34252 13.0571C7.86326 12.8731 8.43455 13.1461 8.61852 13.6669C9.3604 15.7667 11.4017 17.1228 13.625 16.9927C15.8482 16.8627 17.7175 15.2778 18.2094 13.1058C18.7014 10.9337 17.6975 8.69812 15.7472 7.62277Z"
        />
      </svg>
    );
  }
);
